export const tabpanel = {
    root: {
        className: 'p-0 border border-gray-300'
    },
    content: {
        className: 'p-0'
    },
    header: {
        classnames: 'border border-red'
    },
    headerTitle: {
        className: ''
    },
    headerAction: {
        className: 'tabs-item items-center cursor-pointer flex overflow-hidden border-b border-gray-300 relative select-none text-decoration-none user-select-none p-4 font-bold transition-shadow duration-200 m-0 transition-colors duration-200 focus:outline-none focus:outline-offset-0 dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] border-gray-300 bg-white text-gray-700 hover:bg-white hover:border-gray-400 hover:text-gray-600 dark:bg-gray-900 dark:border-blue-900/40 dark:text-white/80 dark:hover:bg-gray-800/80'
    }
}